export default __webpack_public_path__ + "static/alert-message-e563a95070219964304890f52df2ce6b.webp";